import React, { useEffect, useState } from 'react';
import {
    creativeMediaKindLabel,
    creativeSlotLabel,
    creativeVideoMimeTypeFromUrl,
    isCreativeVideoUrl,
} from '../../utils/creativeAspectRatio';
import './CampaignCreativePreview.css';

export default function CampaignCreativePreview({
    src,
    alt = 'Campaign creative',
    className = 'advertismentImage',
    slot,
    showLabel = false,
}) {
    const [renderAs, setRenderAs] = useState(() => (isCreativeVideoUrl(src) ? 'video' : 'image'));
    const [resolvedKind, setResolvedKind] = useState(() => (isCreativeVideoUrl(src) ? 'video' : 'image'));
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        const initial = isCreativeVideoUrl(src) ? 'video' : 'image';
        setRenderAs(initial);
        setResolvedKind(initial);
        setFailed(false);
    }, [src]);

    if (!src) {
        return null;
    }

    const isVideoUrl = isCreativeVideoUrl(src);

    const handleImageError = () => {
        if (!isVideoUrl && renderAs === 'image') {
            setRenderAs('video');
            return;
        }
        setFailed(true);
    };

    const handleVideoError = () => {
        setFailed(true);
    };

    const media = failed ? (
        <div className="creativePlaceholder">Preview unavailable</div>
    ) : renderAs === 'video' ? (
        <video
            className={className}
            controls
            muted
            playsInline
            loop
            preload="metadata"
            onLoadedData={() => setResolvedKind('video')}
            onError={handleVideoError}
        >
            <source src={src} type={creativeVideoMimeTypeFromUrl(src)} />
        </video>
    ) : (
        <img
            className={className}
            src={src}
            alt={alt}
            onLoad={() => setResolvedKind('image')}
            onError={handleImageError}
        />
    );

    return (
        <div className="campaignCreativePreviewCard">
            {showLabel && slot && (
                <span className="campaignCreativePreviewLabel">
                    {creativeSlotLabel(slot)} · {creativeMediaKindLabel(resolvedKind)}
                </span>
            )}
            {media}
        </div>
    );
}
